import "./SimpleTable.css";

interface TableProps {
  columns: Array<{
    header: string;
    accessor: string; // Supports nested keys like 'price_summary.total_price'
    width?: string;
    align?: "left" | "center" | "right";
    render?: (value: any, row: any) => JSX.Element;
  }>;
  data: Array<{ [key: string]: any }>;
}

// Helper function to get nested value
const getNestedValue = (obj: any, path: string): any => {
  return path.split(".").reduce((acc, key) => acc && acc[key], obj);
};

const SimpleTable: React.FC<TableProps> = ({ columns, data }) => {
  return (
     <div className="table-scroll-wrapper">
      <table className="simpleTable">
        <thead>
          <tr>
            {columns.map((column) => (
              <th
                key={column.accessor}
                style={{ width: column.width, textAlign: column.align || "left" }}
              >
                {column.header}
              </th>
            ))}
          </tr>
        </thead>
        <tbody>
          {data.map((row, index) => {
            const inactive = Number(row.is_active) === 0;

            return (
              <tr
                key={index}
                className={inactive ? "row-inactive" : ""}
              >
                {columns.map((column) => (
                  <td
                    key={column.accessor}
                    style={{
                      width: column.width,
                      textAlign: column.align || "left",
                    }}
                  >
                    {(() => {
                      const value = getNestedValue(row, column.accessor);
                      if (column.render) return column.render(value, row);
                      if (
                        value === null ||
                        value === undefined ||
                        typeof value === "string" ||
                        typeof value === "number" ||
                        typeof value === "boolean"
                      ) {
                        return value;
                      }
                      if (Array.isArray(value)) return value.join(", ");
                      if (typeof value === "object") return JSON.stringify(value);
                      return String(value);
                    })()}
                  </td>
                ))}
              </tr>
            );
          })}
        </tbody>
      </table>
    </div>
  );
};

export default SimpleTable;
